import { limitAsync } from 'es-toolkit'

// Runs `worker` over every item with at most `concurrency` in flight. A
// failed item doesn't stop the rest; the number of failures is returned.
export async function runWithConcurrencyLimit<T>(
  items: T[],
  concurrency: number,
  worker: (item: T) => Promise<void>,
): Promise<number> {
  const limitedWorker = limitAsync(worker, concurrency)
  const results = await Promise.allSettled(
    items.map((item) => limitedWorker(item)),
  )
  return results.filter((result) => result.status === 'rejected').length
}

export function saveBlob(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}
